<template>
  <div
    class="modal fade"
    id="carModelManagement"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeModal"
            :disabled="isModelEditing || isSegmentEditing"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.CMM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" style="margin-bottom: 15px">
            <li class="active">
              <a
                href="#editCarModelsTab"
                data-toggle="tab"
                :disabled="isModelEditing || isSegmentEditing"
                >{{ lang.CMM001 }}</a
              >
            </li>
            <li>
              <a
                href="#editCarSegmentsTab"
                data-toggle="tab"
                :disabled="isModelEditing || isSegmentEditing"
                >{{ lang.CMM002 }}</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade active in" id="editCarModelsTab">
              <div class="panel-body">
                <div class="col-md-9">
                  <div class="form-group">
                    <label
                      for="inputNewCarModel"
                      class="col-md-3 control-label"
                      >{{ lang.CMM003 }}</label
                    >
                    <div class="col-md-9">
                      <input
                        id="inputNewCarModel"
                        type="text"
                        class="form-control"
                        v-model="newModel"
                        @keydown.enter="addNewModel()"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputNewCarModel"
                      class="col-md-3 control-label"
                      >{{ lang.CMM004 }}</label
                    >
                    <div class="col-md-9">
                      <select2 v-model="selectedSegments" :multiple="true">
                        <option
                          v-for="segment in segmentList"
                          :key="segment.CarSegmentGuid"
                          :value="segment.CarSegmentGuid"
                        >
                          {{ segment.CarSegmentName }}
                        </option>
                      </select2>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-raised dialog-btn-primary"
                  style="margin-top: 0px"
                  :disabled="
                    !newModel || !selectedSegments[0] || isModelEditing
                  "
                  @click="addNewModel()"
                >
                  {{ lang.CMM005 }}
                </button>

                <div id="carModelTableContainer" class="col-md-12">
                  <table
                    class="table table-striped table-hover"
                    id="carModelTable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center col-md-7">{{ lang.CMM006 }}</th>
                        <th class="text-center col-md-3">{{ lang.CMM007 }}</th>
                        <th class="text-center col-md-2">{{ lang.CMM008 }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="button"
                        v-for="(model, index) in modelList"
                        :key="index"
                        :class="{ info: model.editing }"
                      >
                        <td
                          class="nopadding"
                          @dblclick="editModel($event, model)"
                        >
                          <div class="form-group nopadding">
                            <input
                              type="text"
                              class="form-control text-center nopadding"
                              readonly="true"
                              v-model="model.CarModelName"
                            />
                          </div>
                        </td>
                        <td
                          @dblclick="editModel($event, model)"
                          :class="{ nopadding: model.editing }"
                        >
                          <div v-if="model.editing" class="form-group">
                            <select2
                              id="select-carsegment"
                              @change="carSegmentsOfModelChanged(model, $event)"
                              :value="getCarSegmentsGuidList(model)"
                              :multiple="true"
                            >
                              <option
                                v-for="segment in segmentList"
                                :key="segment.CarSegmentGuid"
                                :value="segment.CarSegmentGuid"
                              >
                                {{ segment.CarSegmentName }}
                              </option>
                            </select2>
                          </div>
                          <span v-else>{{
                            getCarSegmentNameList(model.CarSegments)
                          }}</span>
                        </td>
                        <td
                          class="nopadding"
                          id="carModelActionButtonContainer"
                        >
                          <button
                            type="button"
                            class="btn"
                            @click="editModel($event, model)"
                            v-show="!model.editing"
                            :disabled="isModelEditing"
                          >
                            <i class="material-icons md-24">edit</i>
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="saveModel($event, model)"
                            v-show="model.editing"
                          >
                            <i class="material-icons md-24 text-primary"
                              >save</i
                            >
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="deleteModel(model)"
                            v-show="!model.editing"
                            :disabled="isModelEditing"
                          >
                            <i class="material-icons md-24 text-red">clear</i>
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="undoModelChanges($event, model)"
                            v-show="model.editing"
                          >
                            <i class="material-icons md-24 text-primary"
                              >undo</i
                            >
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="editCarSegmentsTab">
              <div class="panel-body">
                <div class="form-group col-md-12">
                  <label for="inputNewSegment" class="col-md-2 control-label">{{
                    lang.CMM009
                  }}</label>
                  <div class="col-md-7">
                    <input
                      id="inputNewSegment"
                      type="text"
                      class="form-control"
                      v-model="newSegment"
                      @keydown.enter="addNewSegment()"
                    />
                  </div>
                  <button
                    type="button"
                    class="btn btn-raised dialog-btn-primary"
                    style="margin-top: 0px"
                    :disabled="!newSegment || isSegmentEditing"
                    @click="addNewSegment()"
                  >
                    {{ lang.CMM005 }}
                  </button>
                </div>

                <div id="segmentTableContainer" class="col-md-12">
                  <table
                    class="table table-striped table-hover"
                    id="segmentsTable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center col-md-10">{{ lang.CMM006 }}</th>
                        <th class="text-center col-md-2">{{ lang.CMM008 }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="button"
                        v-for="(segment, index) in segmentList"
                        :key="index"
                        :class="{ info: segment.editing }"
                      >
                        <td class="nopadding">
                          <div class="form-group nopadding">
                            <input
                              type="text"
                              class="form-control text-center nopadding"
                              readonly="true"
                              @dblclick="editSegment($event, segment)"
                              @blur="
                                segment.CarSegmentName !==
                                  segment.prevCarSegmentName ||
                                  undoSegmentChanges($event, segment)
                              "
                              v-model="segment.CarSegmentName"
                            />
                          </div>
                        </td>
                        <td class="nopadding" id="segmentActionButtonContainer">
                          <button
                            type="button"
                            class="btn"
                            @click="editSegment($event, segment)"
                            v-show="!segment.editing"
                            :disabled="isSegmentEditing"
                          >
                            <i class="material-icons md-24">edit</i>
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="saveSegment($event, segment)"
                            v-show="segment.editing"
                          >
                            <i class="material-icons md-24 text-primary"
                              >save</i
                            >
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="deleteSegment(segment)"
                            v-show="!segment.editing"
                            :disabled="isSegmentEditing"
                          >
                            <i class="material-icons md-24 text-red">clear</i>
                          </button>
                          <button
                            type="button"
                            class="btn"
                            @click="undoSegmentChanges($event, segment)"
                            v-show="segment.editing"
                          >
                            <i class="material-icons md-24 text-primary"
                              >undo</i
                            >
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised"
            @click="closeModal"
            :disabled="isModelEditing || isSegmentEditing"
          >
            {{ lang.CMM010 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "@/components/Tools/Select2";

export default {
  name: "CarModelManagement",
  components: { select2 },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newModel: "",
      newSegment: "",
      selectedSegments: [],
      segmentList: [],
      modelList: [],
      isModelEditing: false,
      isSegmentEditing: false,
      lang: {
        CMM000: "Car Models",
        CMM001: "Models",
        CMM002: "Segments",
        CMM003: "New model name",
        CMM004: "Segments",
        CMM005: "Add",
        CMM006: "Name",
        CMM007: "Segments",
        CMM008: "Actions",
        CMM009: "New segment name",
        CMM010: "Close",
        CMM011: "Car model already exists",
        CMM012: "Car model created",
        CMM013: "Car model creation failed",
        CMM014: "Car model updated",
        CMM015: "Car model update failed",
        CMM016: "Car model deleted",
        CMM017: "Car model deletion failed",
        CMM018: "Delete Car Model",
        CMM019: "Yes",
        CMM020: "No",
        CMM021: "Do you really want to delete the following car model?",
        CMM022: "Incomplete data",
        CMM023: "Segment already exists",
        CMM024: "Segment created",
        CMM025: "Segment creation failed",
        CMM026: "Segment updated",
        CMM027: "Segment update failed",
        CMM028: "Segment deleted",
        CMM029: "Segment deletion failed",
        CMM030: "Delete Segment",
        CMM031: "Do you really want to delete the following segment?",
        CMM032:
          "ATTENTION: Car models will also be deleted if they are not assigned to any other segment!",
        CMM033: "Please select a segment name",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#carModelManagement").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
  methods: {
    openModal() {
      this.newModel = "";
      this.newSegment = "";
      this.isModelEditing = false;
      this.isSegmentEditing = false;
      this.globals.getCarSegmentList((data) => {
        this.segmentList = data;
        if (data[0] && data[0].CarSegmentGuid)
          this.$nextTick(() => {
            this.selectedSegments = [data[0].CarSegmentGuid];
          });
      });
      this.globals.getCarModelList((data) => (this.modelList = data));
      $("#carModelManagement").modal("show");
    },
    closeModal() {
      this.globals.carModelList = [];
      this.globals.carSegmentList = [];
      $("#carModelManagement").modal("hide");
    },
    getCarSegmentNameList(segments) {
      if (!segments || !segments[0] || !this.segmentList[0]) return "";
      let result = "";
      for (let seg of segments) {
        let segmentObject = _.find(
          this.segmentList,
          (s) => s.CarSegmentGuid === seg.CarSegmentGuid
        );
        if (segmentObject && segmentObject.CarSegmentName) {
          if (result.length > 0) result += ", ";
          result += segmentObject.CarSegmentName;
        }
      }
      return result;
    },
    getCarSegmentsGuidList(model) {
      let result = [];
      for (let segment of model.CarSegments)
        result.push(segment.CarSegmentGuid);
      return result;
    },
    carSegmentsOfModelChanged(model, e) {
      model.CarSegments = [];
      for (let guid of e) {
        model.CarSegments.push({ CarSegmentGuid: guid });
      }
    },
    addNewModel() {
      $("#inputNewCarModel").focus();
      if (!this.newModel || !this.selectedSegments[0] || this.isModelEditing)
        return;
      if (
        _.findIndex(this.modelList, (i) => i.CarModelName === this.newModel) >
        -1
      ) {
        this.globals.showErrorSnackbar(this.lang.CMM011);
        return;
      }
      let postData = {
        CarModelName: this.newModel,
        CarSegments: [],
      };
      this.carSegmentsOfModelChanged(postData, this.selectedSegments);

      $.ajax({
        method: "POST",
        url: `api/CarModel`,
        data: JSON.stringify(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.modelList = data[0] ? data : [];
          this.globals.showSuccessSnackbar(this.lang.CMM012);
          this.newModel = "";
        },
        error: () => {
          console.error("Error on POST in addNewModel()");
          this.globals.showErrorSnackbar(this.lang.CMM013);
        },
      });
    },
    updateModel(model) {
      $.ajax({
        method: "PUT",
        url: `api/CarModel/${model.CarModelGuid}`,
        data: JSON.stringify(model),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.CMM014);
        },
        error: () => {
          console.error("Error on PUT in updateModel()");
          this.globals.showErrorSnackbar(this.lang.CMM015);
        },
      });
    },
    deleteModel(model) {
      if (this.isModelEditing) return;

      this.globals.$off("DeleteCarModelYesConfirmation");
      this.globals.$on("DeleteCarModelYesConfirmation", () => {
        $.ajax({
          method: "DELETE",
          url: `api/CarModel/${model.CarModelGuid}`,
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(
              this.modelList,
              (i) => i.CarModelGuid === model.CarModelGuid
            );
            this.$forceUpdate();
            this.globals.showSuccessSnackbar(this.lang.CMM016);
          },
          error: () => {
            console.error("Error on DELETE in deleteModel()");
            this.globals.showErrorSnackbar(this.lang.CMM017);
          },
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteCarModel",
        confirmationTitle: this.lang.CMM018,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: `<p>${this.lang.CMM021}</p>
                  <p><b>${model.CarModelName}</b></p>`,
      });
    },
    editModel(e, model) {
      if (this.isModelEditing) return;
      model.editing = true;
      this.isModelEditing = true;
      model.prevCarModelName = model.CarModelName;
      model.prevCarSegments = model.CarSegments;
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveModel(e, model) {
      let input = $(e.target).closest("tr").find("input");

      if (!model.CarModelName || !model.CarSegments || !model.CarSegments[0]) {
        this.globals.showErrorSnackbar(this.lang.CMM022);
        input.focus();
        return;
      }

      let count = _.filter(
        this.modelList,
        (i) => i.CarModelName === model.CarModelName
      ).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.CMM011);
        input.focus();
        return;
      }

      this.isModelEditing = false;
      delete model.editing;
      delete model.prevCarModelName;
      delete model.prevCarSegments;
      input.prop("readonly", "true");
      this.updateModel(model);
    },
    undoModelChanges(e, model) {
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isModelEditing = false;
      delete model.editing;
      model.CarModelName = model.prevCarModelName;
      delete model.prevCarModelName;
      model.CarSegments = model.prevCarSegments;
      delete model.prevCarSegments;
    },
    addNewSegment() {
      $("#inputNewSegment").focus();
      if (!this.newSegment || this.isSegmentEditing) return;
      if (
        _.findIndex(
          this.segmentList,
          (i) => i.CarSegmentName === this.newSegment
        ) > -1
      ) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        return;
      }
      let postData = {
        CarSegmentName: this.newSegment,
      };
      $.ajax({
        method: "POST",
        url: `api/CarModel/CarSegment`,
        data: JSON.stringify(postData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.segmentList = data[0] ? data : [];
          this.globals.showSuccessSnackbar(this.lang.CMM024);
          this.newSegment = "";
        },
        error: () => {
          console.error("Error on POST in addNewSegment()");
          this.globals.showErrorSnackbar(this.lang.CMM025);
        },
      });
    },
    updateSegment(segment) {
      $.ajax({
        method: "PUT",
        url: `api/CarModel/CarSegment/${segment.CarSegmentGuid}`,
        data: JSON.stringify(segment),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.globals.showSuccessSnackbar(this.lang.CMM026);
        },
        error: () => {
          console.error("Error on PUT in updateSegment()");
          this.globals.showErrorSnackbar(this.lang.CMM027);
        },
      });
    },
    deleteSegment(segment) {
      if (this.isSegmentEditing) return;

      this.globals.$off("DeleteSegmentYesConfirmation");
      this.globals.$on("DeleteSegmentYesConfirmation", () => {
        $.ajax({
          method: "DELETE",
          url: `api/CarModel/CarSegment/${segment.CarSegmentGuid}`,
          success: (data) => {
            if (data.Error) {
              console.error(data.Error);
              this.globals.showErrorSnackbar(data.Error);
              return;
            }
            _.remove(
              this.segmentList,
              (i) => i.CarSegmentGuid === segment.CarSegmentGuid
            );
            _.remove(
              this.modelList,
              (i) =>
                i.CarSegments.length === 1 &&
                i.CarSegments[0].CarSegmentGuid === segment.CarSegmentGuid
            );
            this.$forceUpdate();
            this.globals.showSuccessSnackbar(this.lang.CMM028);
          },
          error: () => {
            console.error("Error on DELETE in deleteSegment()");
            this.globals.showErrorSnackbar(this.lang.CMM029);
          },
        });
      });

      this.globals.$emit("openGlobalConfirmationDialog", {
        initiator: "DeleteSegment",
        confirmationTitle: this.lang.CMM030,
        colorRed: true,
        yesButtonText: this.lang.CMM019,
        noButtonText: this.lang.CMM020,
        htmlText: `<p>${this.lang.CMM031}</p>
                  <p><b>${segment.CarSegmentName}</b></p>
                  <p>${this.lang.CMM032}</p>`,
      });
    },
    editSegment(e, segment) {
      if (this.isSegmentEditing) return;
      segment.editing = true;
      this.isSegmentEditing = true;
      segment.prevCarSegmentName = segment.CarSegmentName;
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "");
      input.focus();
    },
    saveSegment(e, segment) {
      let input = $(e.target).closest("tr").find("input");

      if (!segment.CarSegmentName) {
        this.globals.showErrorSnackbar(this.lang.CMM033);
        input.focus();
        return;
      }

      let count = _.filter(
        this.segmentList,
        (i) => i.CarSegmentName === segment.CarSegmentName
      ).length;
      if (count > 1) {
        this.globals.showErrorSnackbar(this.lang.CMM023);
        input.focus();
        return;
      }

      this.isSegmentEditing = false;
      delete segment.editing;
      delete segment.prevCarSegmentName;
      input.prop("readonly", "true");
      this.updateSegment(segment);
    },
    undoSegmentChanges(e, segment) {
      let input = $(e.target).closest("tr").find("input");
      input.prop("readonly", "true");
      this.isSegmentEditing = false;
      delete segment.editing;
      segment.CarSegmentName = segment.prevCarSegmentName;
      delete segment.prevCarSegmentName;
    },
  },
};
</script>

<style>
#carModelTable .select2-container {
  margin: 0;
}
</style>

<style scoped>
#carModelTableContainer,
#segmentTableContainer {
  max-height: calc(100vh - 345px);
  overflow: auto;
  padding: 0;
  margin: 20px 0 0 0;
  border: 1px solid lightgray;
}
#carModelTableContainer {
  max-height: calc(100vh - 390px);
}

#carModelTable input:read-only,
#segmentsTable input:read-only {
  cursor: pointer;
  background-image: none !important;
}

#carModelActionButtonContainer > .btn,
#segmentActionButtonContainer > .btn {
  padding: 0px;
  margin: 7px;
}

.nav a[disabled] {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// CarModelManagement.vue?4c3b890a